// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3p1w6","log":"ModalInventoryLogs_log__30r8a","date":"ModalInventoryLogs_date__3iGZP","userName":"ModalInventoryLogs_userName__232BG"};